/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';

import { actions } from './constants';
import { selectError } from '../../store/error/errorSelector';
import { selectAllAssignedPermissions } from '../../store/auth/authSelector';

export const checkAuthzPermission = (action: string, resource: any) => {
  return resource.entity.actions.includes(action);
};

export const CheckAuthzPermissions = (props: { action: string; resource: string; children: any }) => {
  const assignedPermissions = useSelector(selectAllAssignedPermissions);
  const error = useSelector(selectError);
  const hasPermission =
    assignedPermissions &&
    assignedPermissions.resources &&
    checkAuthzPermission(props.action, assignedPermissions.resources[props.resource]);
  return hasPermission ? props.children : (props.action === actions.VIEW) ? (<Typography data-testid="errorAdmins" gutterBottom variant="body1">{`${error?.message ? error.message : `Subject not permitted to view the ${props.resource}`}`}</Typography>) : '';
};